<!-- Launch -->
<ng-container>
  <a *ngIf="canLaunch()" mat-raised-button color="primary" [routerLink]="['/erm/launch/client', env?.environmentId]">
    Launch
  </a>
  <a *ngIf="!canLaunch()" mat-raised-button color="primary" [disabled]="true">
    Launch
  </a>
</ng-container>